var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShieldSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_495_8852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 21.0833C9.77778 21.0833 9.66667 21.0833 9.55556 20.9917C9.11111 20.8083 0 16.9583 0 11V4.58332C0 4.21666 0.333333 3.84999 0.666667 3.75833L9.55556 1.00833C9.77778 0.916659 10.1111 0.916659 10.3333 1.00833L19.2222 3.75833C19.6667 3.84999 20 4.21666 20 4.58332V11C20 16.9583 10.8889 20.8083 10.4444 20.9917C10.3333 21.0833 10.2222 21.0833 10 21.0833ZM2.22222 5.22499V11C2.22222 15.125 8.22222 18.2417 10 19.1583C11.7778 18.3333 17.7778 15.2167 17.7778 11V5.22499L10 2.84166L2.22222 5.22499Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_495_8852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShieldSecurity);
export default __webpack_public_path__ + "static/media/ic_shield_security.4004dd88200d6b3f3619c3c049c42a67.svg";
export { ForwardRef as ReactComponent };